import { Reducer } from 'redux';

import { mergeTwoLists, OpenCashTransactions } from '../models/OpenCashTransactions';
import { GetOpenCashTransactionsActionTypes, GetOpenCashTransactionsActions } from '../actions/GetOpenCashTransactions';
import { IErrorActionData } from '../../../models/Error';
import { PageInfo } from '../../../models/PageInfo';
import { defaultPageSize } from '../../../constants/Common';

export interface IGetOpenCashTransactionsState {
  openCashTransactions: OpenCashTransactions;
  pageInfo: PageInfo;
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initialOpenCashTransactionsState = {
  openCashTransactions: new OpenCashTransactions([]),
  pageInfo: new PageInfo({
    pageSize: defaultPageSize,
    pageNumber: 0,
    hasNext: false,
    cursor: 0,
  }),
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IGetOpenCashTransactionsState;

const GetOpenCashTransactionsReducer: Reducer<IGetOpenCashTransactionsState, GetOpenCashTransactionsActions> = (
  state = initialOpenCashTransactionsState,
  action: GetOpenCashTransactionsActions,
): IGetOpenCashTransactionsState => {
  switch (action.type) {
    case GetOpenCashTransactionsActionTypes.GET_OPEN_CASH_TRANSACTIONS:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case GetOpenCashTransactionsActionTypes.GET_OPEN_CASH_TRANSACTIONS_SUCCESS: {
      const newOpenCashTransations = mergeTwoLists(
        state.openCashTransactions.openCashTransactions,
        action.payload.openCashTransactions,
      );
      return {
        ...state,
        openCashTransactions: new OpenCashTransactions(newOpenCashTransations),
        pageInfo: new PageInfo({
          pageSize: action.payload.pageInfo?.pageSize,
          hasNext: action.payload.pageInfo?.hasNext,
          pageNumber: action.payload.pageInfo?.pageNumber,
          totalPages: action.payload.pageInfo?.totalPages,
          cursor: action.payload.pageInfo?.cursor,
        }),
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };
    }

    case GetOpenCashTransactionsActionTypes.GET_OPEN_CASH_TRANSACTIONS_FAILED:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case GetOpenCashTransactionsActionTypes.GET_OPEN_CASH_TRANSACTIONS_RESET:
      return initialOpenCashTransactionsState;

    default:
      return state;
  }
};

export default GetOpenCashTransactionsReducer;
